import { Component, Input, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import {
  AppTableComponent, ModalWindowComponent, SearchModel, SearchResultModel,
  Auth, MessagesComponent, ViewState, DocumentFileModel, DocumentsService, DocumentFileSaveModel, DocumentFileDownloadModel
} from 'src/common';
import { DocumentComponentName } from 'src/common/enums/documentComponentName';
import { TranslationManager } from 'src/common/translation';


@Component({
  selector: 'documents',
  templateUrl: 'documents.component.html'
})

export class DocumentsComponent implements AfterViewInit, OnInit {

  @Input() id: number;
  @Input() documentComponentsName: DocumentComponentName;
  @Input() title1: string;
  @Input() title2: string;
  @Input() state: ViewState;
  viewState = ViewState;

  constructor(private service: DocumentsService) { }

  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  @ViewChild("modalWindow") modalWindow: ModalWindowComponent;
  items: DocumentFileModel[];
  idForDelete: number;
  showDeleteModal: boolean = false;
  auth = Auth;

  fileToUpload: File = null;
  translationManager = TranslationManager;
  documentToUpload: DocumentFileSaveModel;
  MaxFileSize: number = 1048576 * 20;

  ngOnInit(): void {
    // Auth.checkAuthorization('549249E5-B7DD-4C86-A188-4E2BB6C1ABBE');
  }

  ngAfterViewInit(): void {
    this.appTable.onSearch = this.doSearch.bind(this);
    this.appTable.search();
  }

  doSearch(search: SearchModel) {
    this.service.searchDocument(search, this.id, this.documentComponentsName).then((result: SearchResultModel<DocumentFileModel>) => {
      this.items = result.items;
      this.appTable.setTotalCount(result.totalCount);
    })
  }

  deleteConfirmed() {
    this.showDeleteModal = false;
    this.service.deleteDocument(this.idForDelete,this.documentComponentsName).then(() => {
      this.service.getAllDocument(this.id, this.documentComponentsName).then((items: DocumentFileModel[]) => {
        this.items = items;
      });
      MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно обрисани')]);
    });
  }

  delete(id: number): void {
    this.idForDelete = id;
    this.showDeleteModal = true;
    this.showModal();
  }

  showModal() {
    this.showDeleteModal = true;
  }

  handleFileInput(event): void {

    const files:FileList= event.target.files;
    this.fileToUpload=files.item(0);

    if (this.fileToUpload)
    {
      if (this.fileToUpload.size > this.MaxFileSize) {
        MessagesComponent.instance.showError([this.translationManager.getTranslation('Величина датотеке треба да буде мања од 20 МБ')]);
        return;
      }
      this.documentToUpload = new DocumentFileSaveModel();
      this.documentToUpload.name = this.fileToUpload.name;
      // this.documentToUpload.documentId = this.id;
      this.documentToUpload.requestId = this.id;
      this.documentToUpload.documentComponentName=this.documentComponentsName;
      const reader = new FileReader();
      reader.readAsArrayBuffer(this.fileToUpload);
      reader.onload = () => {
        const base64 = reader.result as ArrayBuffer;
        const attachment = new Uint8Array(base64);
        this.documentToUpload.content = this.arrayBufferToBase64String(attachment); //attachment;
        this.saveFileToDatabase();

        event.target.value=null;

      };
    } else {
      MessagesComponent.instance.showError([this.translationManager.getTranslation('Фајл не постоји')]);
    }
  }

  saveFileToDatabase() {
    if (this.documentToUpload.content === null || this.documentToUpload.content == undefined) {
      MessagesComponent.instance.showError([this.translationManager.getTranslation('Фајл не постоји')]);
      return;
    }
    this.service.saveDocument(this.documentToUpload).then(() => {
      MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Успешно сачуван ентитет')]);
      this.service.getAllDocument(this.id, this.documentComponentsName).then((items: DocumentFileModel[]) => {
        this.items = items;
      });

    });
  }

  arrayBufferToBase64String(buffer: ArrayBuffer): string {
    let binaryString = '';
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.byteLength; i++) {
      binaryString += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binaryString);
  }

  downloadFile(id: number): void {
    this.service.downloadDocument(id,this.documentComponentsName).then((data: DocumentFileDownloadModel) => {
      this.download(data.content, data.name);
    }).catch((reason: any) => {
      if (reason !== null) {
        if (reason.status === 400) {
          if (reason.error !== null) {
            if (reason.error.message) {
              const mescustom = reason.error.message;
              MessagesComponent.instance.showError([mescustom]);
            }
          }
        } else {
          MessagesComponent.instance.showError(reason.error.messages);
        }
      }
    });
  }

  private download(base64String, fileName): void {
    const source = `data:application/octet-stream;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = fileName;
    link.target = '_blank';
    link.click();
  }

  checkAddNew() {
    // let result =
    // (
    //   (this.auth.isAuthorized('1F00B0F8-8C09-472E-B8B3-C76005F7ACA5') && this.documentComponentsName===DocumentComponentName.Ticket) ||
    //   (this.auth.isAuthorized('C4DCAFCE-4FA1-4370-9398-E034C29AE8BD') && this.documentComponentsName===DocumentComponentName.Request)
    //  ) && this.state===ViewState.Edit
    // ;
    // return result;
    return this.state===ViewState.Edit;
  }

  checkDownload() {
    let result = true;
    /*(this.auth.isAuthorized('D372FABC-4850-4BEF-8529-A6E0DC078241') && this.documentComponentsName===DocumentComponentName.Ticket) ||
    (this.auth.isAuthorized('C8316023-61C9-46B5-BDAE-8747FC98BF60') && this.documentComponentsName===DocumentComponentName.Request);*/
    return result;
  }

  checkDelete() {
    let result =
    // (
    //   (this.auth.isAuthorized('A2BC2C25-8D34-4A3A-8AEC-C45F25F9E6FB') && this.documentComponentsName===DocumentComponentName.Ticket) ||
    //   (this.auth.isAuthorized('EA7333DE-6FC4-48A5-85EA-B7E0129F55F8') && this.documentComponentsName===DocumentComponentName.Request)
    // ) &&
      this.state===ViewState.Edit;
    return result;
  }

}
